<template>
  <b-row>
    <b-col md="8">
      <b-card class="mb-2">
        <b-tabs>
          <tab-detail />
          <tab-attach-files />
          <tab-select />
        </b-tabs>
      </b-card>
    </b-col>

    <right-tab />
  </b-row>
</template>

<script>
import {
  BRow, BCol, BFormTextarea, BFormGroup, BFormInput, BTab, BTabs, BCard,
} from 'bootstrap-vue'
import CommonTable from '../../table/vue-good-table/CommonTableLawGroup.vue'
import RightTab from './components/RightTab.vue'
import TabDetail from './GroupManage/TabDetail.vue'
import TabSelect from './GroupManage/TabSelect.vue'
import TabAttachFiles from './components/TabAttachFiles.vue'

export default {
  components: {
    BRow,
    BCol,
    BFormTextarea,
    BFormGroup,
    BFormInput,
    BTab,
    BTabs,
    BCard,
    CommonTable,
    RightTab,
    TabDetail,
    TabSelect,
    TabAttachFiles,
  },
  data() {
    const complainDatas = [
      {
        id: '1',
        operator: [{
          personalId: '1234567890123', fullname: 'นาย ทดสอบ1 นะจ๊ะ', address: '55 ถ.พัฒนาการ ซ.พัฒนาการ 12 แขวง/ตำบล พัฒนาการ เขต/อำเภอ พัฒนาการ กรุงเทพมหานคร 10234', mobile: '082-987-6543', birthDate: '02/01/2540', fax: '-', age: 24, email: 'thitsaran.p@gmail.com',
        }],
        attorney: [{
          personalId: '1234567890123', fullname: 'นาย ทดสอบ1 นะจ๊ะ(มอบ)', address: '55 ถ.พัฒนาการ ซ.พัฒนาการ 12 แขวง/ตำบล พัฒนาการ เขต/อำเภอ พัฒนาการ กรุงเทพมหานคร 10234', mobile: '082-987-6543', birthDate: '02/01/2540', fax: '-', age: 24, email: 'thitsaran.p@gmail.com',
        }],
        company: [{ companyId: '123', companyName: 'บริษัท AA', companyDetail: 'ตั้งอยู่ที่ไหน??' }],
        complainDetail: 'ทดสอบร้องเรียน VUE',
        complainMainType: [1, 2],
        complainSubType: [1, 2, 3],
        complainCause: [1, 3, 5],
        complainPlace: [1, 3, 5],
        complainMotive: [1, 5],
        complainPayment: [1, 3],
        isDmediate: false,
      },
      {
        id: '2',
        operator: [{
          personalId: '1234567890555', fullname: 'นาย ทดสอบ2 นะจ๊ะ', address: '55 ถ.พัฒนาการ ซ.พัฒนาการ 12 แขวง/ตำบล พัฒนาการ เขต/อำเภอ พัฒนาการ กรุงเทพมหานคร 10234', mobile: '082-987-6543', birthDate: '02/01/2540', fax: '-', age: 24, email: 'thitsaran.p@gmail.com',
        }],
        attorney: [{
          personalId: '1234567890555', fullname: 'นาย ทดสอบ2 นะจ๊ะ(มอบ)', address: '55 ถ.พัฒนาการ ซ.พัฒนาการ 12 แขวง/ตำบล พัฒนาการ เขต/อำเภอ พัฒนาการ กรุงเทพมหานคร 10234', mobile: '082-987-6543', birthDate: '02/01/2540', fax: '-', age: 24, email: 'thitsaran.p@gmail.com',
        }],
        company: [{ companyId: '123', companyDetail: 'บริษัท BB' }],
        complainDetail: 'ทดสอบร้องเรียน VUE',
        complainMainType: [1, 4],
        complainSubType: [2, 3],
        complainCause: [2, 3, 5],
        complainPlace: [3, 5],
        complainMotive: [1, 3],
        complainPayment: [1, 5],
        isDmediate: true,
      },
    ]

    return {
      complainId: null,
      complainList: complainDatas,
      complainData: [{}],

    }
  },
}
</script>

 <style lang="scss" >
 @import '@core/scss/vue/libs/vue-good-table.scss';
</style>
